<script setup lang="ts">
import {
    faArrowRight,
    faMap,
    faSearch,
} from '@fortawesome/pro-regular-svg-icons';
import { ReserveType } from '@utils/itinerary';
import { TripType } from '@utils/trip';

const { disableChangeSearch } = defineProps<{
    showHotelsOnMap?: boolean;
    showingSuggestions?: boolean;
    changeSearchFixed?: boolean;
    hideDateInTitle?: boolean;
    disableChangeSearch?: boolean;
}>();

const emit = defineEmits<{
    showSearch: [];
    toggleMaps: [];
}>();

const itineraryStore = useItineraryStore();
const currentModule = useCurrentItineraryModule();
const { srpImageAlt, mainTitle, dateTitle } = moduleToRefs(currentModule.value);
const { isSelectingReturn, expectedPackagesToBeSelected } =
    storeToRefs(itineraryStore);
const searchFormStore = useSearchFormStore();
const { reserveType, haveSuggestions } = storeToRefs(searchFormStore);
const flightForm = useFlightForm();
const { tripType, isDomestic } = moduleToRefs(flightForm);

const columnTitleText = computed(
    () =>
        reserveType.value === ReserveType.Flight &&
        !isDomestic.value &&
        tripType.value === TripType.RoundTrip
);

const router = useRouter();

const isHotelReserve = computed(() => reserveType.value === ReserveType.Hotel);

const showTicketHelper = computed(() => {
    if (expectedPackagesToBeSelected.value === 2) {
        return !(reserveType.value === ReserveType.Flight && !isDomestic.value);
    }
    return false;
});
const onClick = () => {
    if (!disableChangeSearch) {
        emit('showSearch');
    }
};
</script>
<template>
    <div
        class="page-title-wrapper"
        :class="{
            'show-map': showHotelsOnMap,
            hotel: isHotelReserve,
        }"
    >
        <div
            class="page-title-container"
            :class="{
                'change-search-fixed': changeSearchFixed,
                'suggestion-show':
                    !showHotelsOnMap && showingSuggestions && changeSearchFixed,
                hotel: isHotelReserve,
            }"
            @click="onClick"
        >
            <mr-button
                v-if="!haveSuggestions"
                key="back-button-mobile"
                :icon-button="{
                    icon: faArrowRight,
                    color: 'white',
                }"
                size="medium"
                variant="transparent"
                class="mobile-only back-home-button"
                @click.stop="router.push('/')"
            />
            <div
                class="title-texts"
                :class="{
                    'column-title-text': columnTitleText,
                }"
            >
                <div v-if="showTicketHelper" class="prefix mobile-only">
                    {{ isSelectingReturn ? 'برگشت' : 'رفت' }}&nbsp;:&nbsp;
                </div>
                <h1>{{ mainTitle }}</h1>
                <ClientOnly>
                    <div v-if="!hideDateInTitle" class="suffix mobile-only">
                        &nbsp;{{ dateTitle }}
                    </div>
                </ClientOnly>
            </div>
            <mr-icon
                v-if="!disableChangeSearch"
                class="search-icon mobile-only"
                :icon="faSearch"
                color="white"
            />
        </div>
        <img
            class="image-background"
            :alt="srpImageAlt ?? 'مِستربلیط'"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAwAAAADICAYAAABf0obKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQESURBVHgB7ddBAQAQAAAxFFBaah+C3NZic5/7BgAAkLAGAACQIQAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQ8gFHNgQcV0aoRAAAAABJRU5ErkJggg=="
        />
    </div>
    <div
        v-if="isHotelReserve"
        class="show-map-container"
        @click="emit('toggleMaps')"
    >
        <mr-button
            class="show-map-button"
            :right-icon="faMap"
            size="big"
            variant="transparent"
            full-width
        >
            مشاهده هتل‌ها روی نقشه
        </mr-button>
    </div>
</template>
<style scoped lang="scss">
.page-title-wrapper {
    @include mobile-only {
        position: relative;
        height: 64px;
        &.hotel {
            height: 48px;
        }
        &.show-map {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 10000000000;
        }
    }
    .image-background {
        display: none;
        @include mobile-only {
            position: absolute;
            display: flex;
            bottom: 0;
            left: 0;
            right: 0;
            max-width: 100%;
            height: 350px;
        }
    }
    .page-title-container {
        display: flex;
        align-items: center;
        height: 72px;
        @include shadow(1);
        background: white;
        border-radius: 12px;
        padding: 16px;
        @include mobile-only {
            height: 64px;
            @include shadow(0);
            border-radius: 0;
            width: 100%;
            background: usePalette();
            margin: 0;
            z-index: 1001;
            position: absolute;
            top: 0;
            &.change-search-fixed {
                position: fixed;
            }
            &.suggestion-show {
                transform: translateY(48px);
            }
            .back-home-button {
                flex: 0 0 40px;
            }

            .title-texts {
                flex: 1 1 auto;
                display: flex;
                align-items: center;
                overflow: hidden;
                &.column-title-text {
                    flex-direction: column;
                    align-items: flex-start;
                    .suffix {
                        margin-right: -7px;
                    }
                }
                .prefix {
                    flex: 0 0 auto;
                    @include tg-m($w7, white);
                }
                h1 {
                    flex: 0 0 auto;
                    @include tg-m($w5, white);
                    white-space: nowrap;
                }
                .suffix {
                    flex: 0 1 auto;
                    @include tg-m($w5, white);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            .search-icon {
                flex: 0 0 18px;
                &:before {
                    color: white;
                }
            }
        }
        h1 {
            @include tg-l($w7, usePalette($p-blue, $p-600));
            margin: 0;
        }
        &.hotel {
            @include shadow(0);
            height: 48px;
            padding: 8px 12px;
            background-color: transparent;
            @include mobile-only {
                background-color: usePalette();
            }
        }
    }
}

.show-map-container {
    @include shadow(1);
    position: relative;
    width: 100%;
    height: 140px;
    background-image: url('/img/Map.png');
    border-radius: 12px;
    margin-bottom: 8px;
    overflow: hidden;

    .show-map-button {
        position: absolute;
        bottom: 0;
        background: white !important;
        border-radius: 0 !important;
    }
    @include mobile-only() {
        display: none;
    }
}
</style>
